import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import {
  UpdateWorkordersConfigurationProfile,
  WorkorderConfigurationCompany,
  WorkordersConfigurationProfile,
} from './WorkordersConfiguration.types';

const CONTROLLER_URL = `${API_BASE_URL}/workorders/configuration`;

export async function listWorkorderConfigurationProfile(): Promise<
  PageResult<WorkordersConfigurationProfile>
> {
  const result = (await api.get(`${CONTROLLER_URL}/profile`, null)) as unknown;

  return result as PageResult<WorkordersConfigurationProfile>;
}

export async function updateWorkorderConfigurationProfile(
  obj: UpdateWorkordersConfigurationProfile,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/profile`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function getWorkorderConfigurationCompany(companyId?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/company/${companyId}`,
    null,
  )) as unknown;

  return result as WorkorderConfigurationCompany;
}

export async function updateWorkorderConfigurationCompany(
  companyId: number,
  obj: WorkorderConfigurationCompany,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/company/${companyId}`,
    obj,
    null,
  )) as unknown;

  return result;
}
